import axios from 'axios';

const BUSINESS_URL = '/business';

// Function to convert Uint8Array into a valid base64 (HTTP GET)
const convertUint8ArrayToBase64 = (uint8Array) => {
  const asciiString = String.fromCharCode.apply(null, uint8Array);
  const trueBase64 = btoa(atob(asciiString));
  return trueBase64;
};

/* function bufferToBase64(buffer, mimeType = 'image/png') {
  const uint8Array = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < uint8Array.length; i++) {
    binary += String.fromCharCode(uint8Array[i]);
  }
  const base64 = btoa(binary);
  return `data:${mimeType};base64,${base64}`;
} */

//:: HTTP GET User's Businesses
const fetchBusinesses = async (userId) => {
  try {
    const response = await axios.get(`${BUSINESS_URL}/user?id=${userId}`);

    if (Array.isArray(response.data)) {
      // Convertimos los logos si existen
      const businessesWithLogos = response.data.map((business) => {
        if (
          business.logo &&
          business.logo.type === 'Buffer' &&
          Array.isArray(business.logo.data)
        ) {
          const base64String = convertUint8ArrayToBase64(
            new Uint8Array(business.logo.data)
          );
          const logoUrl = `data:image/png;base64,${base64String}`;

          return { ...business, logoUrl };
        }
        return business;
      });

      return businessesWithLogos;
    } else {
      console.error('Unexpected response format:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching businesses:', error);
    throw error;
  }
};

//:: HTTP POST a new business
const addBusiness = async (businessData) => {
  try {
    const response = await axios.post(`${BUSINESS_URL}/save`, businessData);
    return response.data;
  } catch (error) {
    console.error('Error adding business:', error);
    throw error;
  }
};

//:: HTTP GET business details
const fetchBusinessDetails = async (businessId) => {
  try {
    const response = await axios.get(`${BUSINESS_URL}/info?id=${businessId}`);

    const business = response.data;

    // Convert the logo if it exists
    if (
      business.logo &&
      business.logo.type === 'Buffer' &&
      Array.isArray(business.logo.data)
    ) {
      const base64String = convertUint8ArrayToBase64(
        new Uint8Array(business.logo.data)
      );
      business.logoUrl = `data:image/png;base64,${base64String}`;
    }

    return business;
  } catch (error) {
    console.error('Error fetching business details:', error);
    throw error;
  }
};

//:: HTTP GET Business active modules
const fetchBusinessActiveModules = async (businessId) => {
  try {
    const response = await axios.get(`${BUSINESS_URL}/info?id=${businessId}`);
    return response.data?.active_modules ?? null;
  } catch (error) {
    console.error('Error fetching business active modules:', error);
    return null;
  }
};

//:: HTTP POST (logo)
const updateBusinessLogo = async (businessId, logoBase64) => {
  try {
    await axios.post(`${BUSINESS_URL}/updatelogo`, {
      id: businessId,
      logo: logoBase64,
    });
  } catch (error) {
    console.error('Error saving logo:', error);
    throw error;
  }
};

//:: HTTP PATCH business details
const updateBusiness = async (businessId, updatedBusinessData, ownerId) => {
  try {
    const response = await axios.patch(`${BUSINESS_URL}/update`, null, {
      params: {
        id: businessId,
        owner_id: ownerId,
        name: updatedBusinessData.name,
        address: updatedBusinessData.address,
        email: updatedBusinessData.email,
        website: updatedBusinessData.website,
        taxid: updatedBusinessData.taxid,
        description: updatedBusinessData.description,
        context: updatedBusinessData.context,
        category: updatedBusinessData.category,
        timezone: updatedBusinessData.timezone,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating business:', error);
    throw error;
  }
};

//:: HTTP PATCH business technical settings
const updateBusinessTechnical = async (businessId, ownerId, name, data) => {
  try {
    const phoneDigits = String(data.phone ?? '').replace(/\D/g, '');
    const response = await axios.patch(`${BUSINESS_URL}/update`, null, {
      params: {
        id: businessId,
        owner_id: ownerId,
        name,
        phone: phoneDigits === '' ? undefined : Number(phoneDigits),
        api_url: data.api_url,
        token: data.token,
        meta_token: data.meta_token,
        meta_phone_id: data.meta_phone_id,
        timezone: data.timezone,
        active_modules: data.active_modules,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating business technical settings:', error);
    throw error;
  }
};

//:: HTTP DELETE a business
const deleteBusiness = async (businessId) => {
  try {
    await axios.delete(`${BUSINESS_URL}/remove?id=${businessId}`);
  } catch (error) {
    console.error('Error deleting business:', error);
    throw error;
  }
};

//:: HTTP GET Business' Users
const fetchUsers = async (businessId) => {
  try {
    const response = await axios.get(
      `${BUSINESS_URL}/users?business_id=${businessId}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

//:: HTTP POST (invite user)
const inviteUser = async (userData) => {
  try {
    const response = await axios.post(`${BUSINESS_URL}/invitation`, userData);
    return response.data;
  } catch (error) {
    console.error('Error inviting user:', error);
    throw error;
  }
};

//:: HTTP PATCH User Role
const updateUserRole = async (businessUserId, userId, businessId, roleId) => {
  try {
    const response = await axios.patch(`${BUSINESS_URL}/user/update`, null, {
      params: {
        bussines_user_id: businessUserId,
        user_id: userId,
        business_id: businessId,
        role_id: roleId,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating user role:', error);
    throw error;
  }
};

//:: HTTP PATCH Business opportunity settings
const updateBusinessOpportunitySettings = async (businessId, defaultOpportunity, assignedOpportunity, ownerId, name, aiMoveOpportunity) => {
  try {
    const response = await axios.patch(`${BUSINESS_URL}/update`, null, {
      params: {
        id: businessId,
        owner_id: ownerId,
        name: name,
        default_opportunity: defaultOpportunity,
        assigned_opportunity: assignedOpportunity,
        ai_move_opportunity: aiMoveOpportunity,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating opportunity settings:', error);
    throw error;
  }
};

//:: HTTP DELETE (revoke access)
const deleteUser = async (businessUserId) => {
  try {
    await axios.delete(
      `${BUSINESS_URL}/user/remove?bussines_user_id=${businessUserId}`
    );
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
};

export {
  fetchBusinesses,
  fetchBusinessActiveModules,
  addBusiness,
  fetchBusinessDetails,
  updateBusinessLogo,
  updateBusiness,
  updateBusinessOpportunitySettings,
  updateBusinessTechnical,
  deleteBusiness,
  fetchUsers,
  inviteUser,
  updateUserRole,
  deleteUser,
};
